import { useQuery } from "@apollo/client";

import { RENTAL, SALE } from "../../constants/dealTypes";
import DealInfo from "../DealInfo";
import parseGqlDataByKey from "../parseGqlDataByKey";
import { getDealPageQuery } from "../queries";
import useFeatureState from "./useFeatureState";

export const getDealKey = ({ contact_id, type }) =>
  `expert_${type}_${contact_id}_deals`;

const useDeals = ({ contact_id = null }) => {
  const { buildingId, segmentName } = useFeatureState();

  const dealsKey = type => getDealKey({ contact_id, type });
  const saleDealsKey = dealsKey(SALE);
  const rentalDealsKey = dealsKey(RENTAL);
  const { rentals, sales, ...rest } = parseGqlDataByKey(
    useQuery(getDealPageQuery(saleDealsKey, rentalDealsKey), {
      variables: {
        expert_id_input: {
          building_id: buildingId,
          contact_id,
          segment_name: segmentName
        },
        rentals_type_input: {
          listing_class: RENTAL
        },
        sales_type_input: {
          listing_class: SALE
        }
      }
    })
  );

  return {
    rentals: new DealInfo(rentals),
    sales: new DealInfo(sales),
    ...rest
  };
};

export default useDeals;
